// extracted by mini-css-extract-plugin
export default {"root":"ListStatus_root__q8W7p","state":"ListStatus_state__j+Lyj","doing":"ListStatus_doing__ZQmRs","done":"ListStatus_done__lE-IP"};